<template>
  <div
    id="signin"
    class="d-flex justify-center">
    <v-form
      id="signin-form"
      @submit.prevent="signIn">
      <!-- DelMar Logo -->
      <img
        id="logo"
        src="../assets/img/logo.png"
      />
      <!-- / DelMar Logo -->

      <!-- Project Name -->
      <v-text-field
        v-model="credentials.projectName"
        label="Project Name"
        placeholder=" "
        :readonly="$store.getters.isLoadingActive">
      </v-text-field>
      <!-- / Project Name -->

      <!-- User ID -->
      <v-text-field
        v-model="credentials.userId"
        label="User ID"
        placeholder=" "
        :readonly="$store.getters.isLoadingActive">
      </v-text-field>
      <!-- / User ID -->

      <!-- Password -->
      <v-text-field
        v-model="credentials.password"
        label="Password"
        type="password"
        placeholder=" "
        :readonly="$store.getters.isLoadingActive">
      </v-text-field>
      <!-- / Password -->

      <!-- Sign In -->
      <v-btn
        class="mt-6"
        type="submit"
        color="primary"
        width="100%"
        :loading="$store.getters.isLoadingActive"
        :readonly="$store.getters.isLoadingActive">
        Sign In
      </v-btn>
      <!-- / Sign In -->
    </v-form>
  </div>
</template>

<script>
import _ from 'lodash';

export default {
  name: 'SignIn',
  data() {
    return {
      credentials: {
        projectName: process.env.VUE_APP_PROJECT_NAME || '',
        userId: process.env.VUE_APP_USER_ID || '',
        password: process.env.VUE_APP_PASSWORD || '',
      },
    };
  },
  methods: {
    signIn() {
      this.$store.dispatch(
        'signIn',
        this.credentials,
      ).then(() => {
        const route = this.$store.state.referrer || { name: 'Content', params: { section: 'all' } };
        this.$store.dispatch('initialize');
        this.$router.replace(route);
        this.$store.commit('clearAuthError');
      }, _.noop);
    },
  },
};
</script>

<style lang="scss">
#signin {
  height: 100vh;

  #signin-form {
    margin-top: 15vh;
    width: 325px;

    #logo {
      display: block;
      width: 300px;
      margin: 0 auto 90px auto;
    }
  }
}
</style>
